import React, { useEffect } from "react";
import MoneyValue from "../MoneyValue/MoneyValue";
import infoIcon2 from "../../assets/images/svg/infoIcon2.svg";
import Chart from "react-apexcharts";
import { observer } from "mobx-react";
import {
  commaSeperated,
  formatDateToLocaleDateString,
  getAsOfDate,
  getDisplayDate,
} from "../../utils/functions";
import UserStore from "../../store/UserStore";

const FinancialValueContainer = observer(({ dataPoint }) => {
  const portfolioData = UserStore[dataPoint]?.clientPortfolioReturn;
  useEffect(() => {
    UserStore.removeInfinity();
  }, []);
  const options = {
    chart: {
      id: "apexchart-example",

      Selection: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      download: false,
      zoom: false,
      sparkline: {
        enabled: false,
      },
    },
    stroke: {
      curve: "smooth",
      lineCap: "butt",
      width: 0.5,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.5,
        opacityTo: 0.8,
        stops: [0, 100],
      },
    },
    colors: ["#00A651"],
    xaxis: {
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      crosshairs: {
        show: false,
      },
      axisBorder: {
        show: false,
        //  color:"rgba(70, 214, 134, 0.18)",
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    grid: {
      show: false,
      padding: {
        top: -10,
        bottom: 0,
        left: 10,
        right: 0,
      },
    },
    tooltip: {
      show: true,

      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return `<div class="arrow_box"><span class="date">${getDisplayDate(
          UserStore[dataPoint]?.portfolioGraphDates[dataPointIndex]
        )}</span>
        <span class="data">${
          commaSeperated(
            UserStore[dataPoint]?.portfolioShowAmount[dataPointIndex]
          ) + UserStore[dataPoint]?.portFolioUnits[dataPointIndex]
        } </span><div>`;
      },
    },

    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    markers: {
      size: 0,
      colors: "#46D686",
      strokeWidth: 2,
      strokeColors: "#fff",
    },
  };

  const series = [
    {
      name: "series-1",
      data: UserStore[dataPoint]?.portfolioGraphSeries || [],
    },
  ];

  return (
    <div className="value_container_outside">
      <div className="area_chart_value_container">
        <MoneyValue
          title="Current Value"
          amount={portfolioData?.current_value?.value || "-"}
          unitType={portfolioData?.current_value?.value_type || ""}
          date1={
            getAsOfDate(portfolioData?.as_of_date)
              ? `As of ${getDisplayDate(
                  getAsOfDate(portfolioData?.as_of_date)
                )}`
              : ""
          }
          hasWidth={true}
        />
        <div>
          <div
            className="chart"
            role="img"
            aria-label="Current value trend over time chart"
            tabIndex={0}
          >
            <Chart
              options={options}
              series={series}
              type="area"
              width={240}
              height={120}
            />
          </div>
          <table id={"chart-table"} className="chart-table-sr-only">
            <caption>Current value over time</caption>

            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Current Value</th>
              </tr>
            </thead>

            <tbody>
              {UserStore?.portfolio?.sortedGraphData?.map((item, index) => (
                <tr key={index}>
                  <td>
                    {formatDateToLocaleDateString({ dateStr: item.date })}
                  </td>
                  <td>
                    {item.amount.value}
                    {item.amount.value_type}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <MoneyValue
        title="Invested Value"
        amount={`${portfolioData?.invested_value?.value || "-"}`}
        unitType={portfolioData?.invested_value?.value_type || ""}
        hasWidth={true}
      />
      <MoneyValue
        title="Unrealised Gains (%)"
        amount={`${portfolioData?.unrealised_gain?.amount?.value || "-"}`}
        unitType={portfolioData?.unrealised_gain?.amount?.value_type || ""}
        batchAmount={portfolioData?.unrealised_gain?.percentage}
        hasWidth={true}
      />
      <MoneyValue
        title="Realised Gain"
        amount={`${portfolioData?.realised_gain?.amount?.value || "-"} `}
        unitType={portfolioData?.realised_gain?.amount?.value_type || ""}
        hasWidth={true}
      />
      <MoneyValue
        totalAndIrr={`${portfolioData?.total_returns?.value || "-"}`}
        totalAndUnit={portfolioData?.total_returns?.value_type || ""}
        title="Total Returns (IRR)"
        infoLogo={infoIcon2}
        amount={`${portfolioData?.irr || "-"}${
          !!portfolioData?.irr ? "%" : ""
        }`}
        hasWidth={true}
        TooltipContent={
          <div className="irr_tip tip_align">
            <h2>Total Returns</h2>
            <p>(Realised + Unrealised + Int/Div and Other Income)</p>
          </div>
        }
        tipClass="main_page"
      />
    </div>
  );
});

export default FinancialValueContainer;
